import { Input } from 'antd'
import { useEffect, useState } from 'react'
import './NeNumberInput.scss'

export const NeNumberInput = ({ value, onChange }) => {
    const [inputValue, setInputValue] = useState('')
    const [isDelete, setIsDelete] = useState(false)

    const handleKeyDown = e => {
        if (e.key === 'Backspace' && e.target.value === '-') {
            setIsDelete(true)
        } else {
            setIsDelete(false)
        }
    }

    const handleChange = e => {
        let result = e.target.value.replace(/[^\d.-]/g, '')
        let result2 = result.split('.')
        let result3
        if (result2.length >= 2) {
            result3 = (result2[0] ?? '') + '.' + (result2[1] ?? '')
        } else {
            result3 = result2[0] ?? ''
        }
        // 负数
        let result4 = result3.split('-')
        let result5
        if (result4[0] === '' && !isDelete) {
            result5 = '-' + result4.join('')
        } else {
            result5 = result4.join('')
        }
        return setInputValue(result5)
    }

    useEffect(() => {
        setInputValue(value)
    }, [])

    useEffect(() => {
        onChange(inputValue)
    }, [inputValue])
    return (
        <Input
            className='numberInput keepRight'
            placeholder=''
            value={inputValue}
            onChange={handleChange}
            allowClear={false}
            onKeyDown={handleKeyDown}
        />
    )
}
